import _ from 'lodash';
import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './compare-service.html';
import moment from 'moment';

const COMPONENT_NAME = 'CompareService';

angular.module (ComponentsModule)
  .factory (COMPONENT_NAME, function ($rootScope, $q, $uibModal, ContentService, UserProfileModal, KeyboardShortcutService) {
    function formatVersionInfo (info) {
      return {
        version: info.version.replace('contentid/', ''),
        creationTime: info.creationTime ? moment(info.creationTime).format('ll, LTS') : 0,
        author: info.creatorId || '',
        patch: info.patch,
        passport: info.passport
      };
    }

    return {
      compareVersions: function (oldVersionInfo, newerVersionInfo) {
        var modalScope = $rootScope.$new(true);
        modalScope.oldVersionInfo = formatVersionInfo(oldVersionInfo);

        if (newerVersionInfo.patch) {
          modalScope.isDraft = true;
        }

        modalScope.newerVersionInfo = formatVersionInfo(newerVersionInfo);
        modalScope.error = undefined;
        modalScope.errorMessage = undefined;
        modalScope.showFullChanges = false;
        modalScope.loading = true;

        var modal = $uibModal.open({
          animation: false,
          backdrop: 'static',
          keyboard: false,
          scope: modalScope,
          template,
          windowClass: 'code-generic-modal ng-cloak'
        });

        modalScope.close = () => {
          modal.close();
          modalScope.$destroy();
        };

        modalScope.$on('$destroy', function () {
          KeyboardShortcutService.pop();
        });

        KeyboardShortcutService.hideAndPush({
          'escape': {
            action: function () {
              modalScope.close();
            },
            label: 'keyboard-shortcuts.close-compare-modal.label'
          }
        });

        modalScope.openUserInModal = function (passport) {
          UserProfileModal.open(modalScope, passport);
        };

        var versionPromises = _.map([oldVersionInfo, newerVersionInfo], function (versionInfo) {
          if (versionInfo.patch) {
            return $q.resolve(versionInfo.patch);
          }
          else {
            return ContentService.getContentVersion({
              version: versionInfo.version,
              fullTypeInfo: true
            })
              .then(function (result) {
                return result.content;
              });
          }
        });

        $q.all(versionPromises)
          .then(function (results) {
            modalScope.contents = results;
            modalScope.loading = false;
          })
          .then(undefined, function (error) {
            console.warn('Error while calculating content changes!', error);
            modalScope.error = error;
            modalScope.loading = false;
            modalScope.errorMessage = (typeof error !== 'undefined' && typeof error.cause !== 'undefined')
              ? error.cause : 'Error while calculating content changes.';
          });
      }
    };
  });

export default COMPONENT_NAME;
